import React, { Component } from "react";
import moment from "moment";
import { Drawer, Table, Tag, Icon } from "antd"; // Added Tag and Icon
import Request from "../../request";
import common from "../../containers/common.less";
import { connect } from "react-redux";
import LatestFollowUp from "../../components/_utils/latestFollowup";

const link = {
    "Front Desk": '/desk/update-counselling',
    "Registration Desk": "/registration/fees",
    "Application Desk": "/desk/allApplication-desk/update",
    "Visa Desk": "/desk/getVisa",
    "Claim Desk": "/desk/getClaim",
    "Archive Desk": "/desk/getClaim",
}

class DashboardStudentList extends Component {
    state = {
        visible: true,
        arr: [],
        loading: false
    };

    componentDidMount() {
        this.loadDashboardStudentList();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    loadDashboardStudentList = async () => {
        this.setState({ loading: true });
        const { arr } = this.props.param;

        let response = await Request.loadDashboardStudentList({
            arr: arr,
            results: 10000,
        });

        if (response) {
            this.setState({ arr: response.data });
        }
        this.setState({ loading: false });
    };

    // ... inside your DashboardStudentList class

    render() {
        const { arr, loading } = this.state;
        const { title, count, bgColorClass, icon } = this.props.param;

        // inside your DashboardStudentList class -> column array

        const column = [
            {
                title: "Student Details",
                key: "student",
                width: "15%",
                render: (text, record) => {
                    const redirectPath = link[record.atLevel] || "#";
                    return (
                        <div className="student-info-wrapper">
                            <span style={{ fontWeight: 700, color: "#1a3353", fontSize: '15px' }}>
                                <a href={`${redirectPath}?id=${record._id}`} target="_blank">
                                    {record.studentName}
                                </a>
                            </span>
                            <Tag style={{ width: 'fit-content', fontSize: '10px', borderRadius: '4px' }}>
                                ID: {record.id}
                            </Tag>
                        </div>
                    )

                }
            },
            {
                title: 'At Stage',
                key: 'atLevel',
                width: "15%",
                render: (val, record) => (
                    <div>{record && record.atLevel}</div>
                )
            },
            {
                title: "Contact Info",
                key: "contact",
                width: "18%",
                render: (val, record) => (
                    <div className="contact-info-wrapper">
                        <div>
                            <Icon type="phone" style={{ marginRight: 8, color: '#1890ff' }} />
                            {record.mobile}
                        </div>
                        <div style={{ color: '#52c41a' }}>
                            <Icon type="whats-app" style={{ marginRight: 8 }} />
                            {record.watsupp || record.mobile}
                        </div>
                        <div style={{ wordBreak: 'break-all', color: '#8c8c8c' }}>
                            <Icon type="mail" style={{ marginRight: 8, color: '#ff4d4f' }} />
                            {record.emailId}
                        </div>
                    </div>
                ),
            },
            {
                title: "Counsellor",
                dataIndex: "counsellorName",
                key: "counsellorName",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Follow Up & Status",
                key: "followUp",
                dataIndex: "followUp",
                width: "30%",
                render: (text) => (
                    <div className="follow-up-cell" style={{ margin: '4px 0' }}>
                        <LatestFollowUp info={text} />
                    </div>
                ),
            },
            {
                title: "Managed By",
                key: "activity",
                width: "15%",
                align: 'right',
                render: (_, record) => {
                    const user = record.updatedByUser || record.createdByUser;
                    return (
                        <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <div style={{ fontWeight: 600, color: '#434343' }}>
                                {user ? user.name : "System"}
                            </div>
                            <div style={{ fontSize: '11px', color: '#bfbfbf' }}>
                                {record.updatedAt ? moment(record.updatedAt).format("lll") : ""}
                            </div>
                        </div>
                    );
                },
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={1250}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <Table
                    dataSource={arr}
                    columns={column}
                    loading={loading}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                />
            </Drawer>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    currentUser: global.currentUser,
});

export default connect(mapStateToProps, null)(DashboardStudentList);